import { CloseIcon, HistoryIcon } from "./icons";
import { templateToText } from "../utils/emailTemplate";

const LABELS = { follow_up_email: "Follow-up" };

const formatSentAt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d) ? "" : d.toLocaleString("en-PH", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
};

// Emails already sent to one financier (get_sent_to_financier history, newest first).
export default function HistoryModal({ open, bankName, history, onClose }) {
  if (!open) return null;
  return (
    <div className="overlay overlay--mail" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="mail-box">
        <div className="mail-box__head">
          <span className="sheet-box__icon">
            <HistoryIcon />
          </span>
          <span className="sheet-box__titles">
            <span className="sheet-box__title">Sent history</span>
            <span className="sheet-box__sub">{bankName}</span>
          </span>
          <button type="button" className="sheet-box__close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="mail-box__body">
          {history.length === 0 && <div className="history-empty">Nothing has been sent to this bank yet.</div>}
          {history.map((h, i) => {
            const docCount = (h.documents || []).length;
            return (
              <div key={(h.template_for || "") + (h.sent_at || "") + i} className="history-entry">
                <div className="history-entry__head">
                  <span className="history-entry__type">{LABELS[h.template_for] || "Sent to Bank"}</span>
                  <span className="history-entry__time">{formatSentAt(h.sent_at)}</span>
                </div>
                <div className="history-entry__meta">
                  <div>To · {h.financier_email || "—"}</div>
                  {h.financier_cc_email && <div>CC · {h.financier_cc_email}</div>}
                  <div>Subject · {h.subject || "—"}</div>
                  <div>
                    {docCount} document{docCount === 1 ? "" : "s"} attached
                  </div>
                </div>
                {h.send_html_template && <div className="history-entry__body">{templateToText(h.send_html_template)}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
